import { IPbrInputProps, PbrInput } from "../PbrInput/PbrInput";
import * as React from "react";
import { WrappedFormUtils } from "antd/lib/form/Form";
import { getEmailRegex } from 'src/util/helper';

export function PbrInputEmail(props: { formWrapper: WrappedFormUtils; isRequired?: boolean; placeHolder?: string } & IPbrInputProps) {

  return (
    <PbrInput
      title="Email"
      formItemProps={{ label: "E-mail" }}
      placeholder={props.placeHolder ? props.placeHolder : "Digite o e-mail do cliente"}
      rules={[
        {
          required: props.isRequired,
          message: "E-mail é obrigatório!",
          pattern: getEmailRegex
        },
        {
          validator: (rule, value, callback) => {
            if (value) {
              const emailValidator = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

              const isEmail = emailValidator.exec(value);
              if (isEmail) {
                callback();
              } else {
                callback("Email inválido.");
              }
            } else {
              callback();
            }
          }
        }
      ]}
      {...props}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/common/PbrInputEmail/PbrInputEmail.tsx